import { useEffect, useState } from 'react';

import {
  useGetLeadsFreeOwnerTimeoutQuery,
  useSetLeadsFreeOwnerTimeoutMutation,
} from '@app/api/Settings';
import { SUCCESS } from '@app/constants';
import { useUserPrint } from '@app/hooks';
import { useNotification } from '@app/providers/NotificationProvider/NotificationContext';
import { handleCatchError } from '@app/services';

export const useDetachResponsibleFromLead = () => {
  const [minutes, setMinutes] = useState<number | null>(null);
  const [never, setNever] = useState(false);

  const { activeBranchId: ActiveBranchId } = useUserPrint();

  const { data, isLoading, error } = useGetLeadsFreeOwnerTimeoutQuery({
    ActiveBranchId,
  });
  const [setFreeOwnerTimeout, { isLoading: isSaving }] =
    useSetLeadsFreeOwnerTimeoutMutation();

  const { showNotification } = useNotification();

  const handleSave = async () => {
    try {
      await setFreeOwnerTimeout({
        ActiveBranchId,
        Value: never ? null : minutes,
      }).unwrap();

      showNotification('Настройки сохранены', SUCCESS);
    } catch (error) {
      showNotification(handleCatchError(error));
    }
  };

  useEffect(() => {
    if (error) showNotification(handleCatchError(error));
  }, [error, showNotification]);

  useEffect(() => {
    if (data) {
      if (data.Value === null) {
        setNever(true);
        setMinutes(null);
      } else {
        setNever(false);
        setMinutes(data.Value);
      }
    }
  }, [data]);

  return {
    minutes,
    setMinutes,
    never,
    setNever,
    handleSave,
    data,
    isLoading,
    isSaving,
  };
};
